const positionTypeMapping = {
  cap: 'Cap',
  bond: 'Bond',
  certificate: 'Certificate',
  'construction-loan': 'ConstructionLoan',
  'credit-facility': 'CreditFacility',
  loan: 'Loan',
  swap: 'Swap',
};

export const convertToPositionType = param => positionTypeMapping[param];
